export interface ILocationAddress {
  city?: string
  state?: string
  countryCode?: string
  name?: string
}

/**
 *
 * @param address @type {ILocationAddress}
 * @returns 'city, state, countryCode - name'
 */
export function buildAddress(address?: ILocationAddress | null): string {
  if (!address) return ''

  const { city, state, countryCode, name } = address

  const parts = [city, state, countryCode].filter(Boolean)

  let result = parts.join(', ')

  if (name) {
    if (result) {
      result += ` - ${name}`
    } else {
      result = name
    }
  }

  return result
}
